import { PRODUCTS, TABLES } from "./TableManger";
import RouteManager, { PAGE_ROUTES } from "./RouteManager";
import NotificationService from "../services/NotificationService";
import { NOTIFICATIONS, NOTIFICATION_MODULE } from "../components/notification/NotificationConstant";
import moment from 'moment'
import ApiConstants from "../constants/ApiConstants";
export default class NotificationManager {
  static notifications = [
    // Note : Comment for Referance and future use 
    // {
    //   id: "1",
    //   title: "A day after the payroll is processed.",
    //   owner: "Payrun Processed",
    //   date: "Sep 23, 2021",
    //   read: false,
    //   type: TABLES.CANDIDATE,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "2",
    //   title: "<b>$ 23,000</b> Deal receive",
    //   owner: "Monica Bel",
    //   date: "May 23, 2021",
    //   read: true,
    //   type: TABLES.DEAL,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "3",
    //   title: "<b>Survey</b> form created",
    //   owner: "Abhijeet Sawant",
    //   date: "Feb 17, 2021",
    //   read: false,
    //   type: TABLES.FORM,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "4",
    //   title: "Form deleted",
    //   owner: "Abhijeet Sawant",
    //   date: "Feb 19, 2021",
    //   read: true,
    //   type: TABLES.FORM,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "5",
    //   title: "Campaign started",
    //   owner: "Tamas Boras",
    //   date: "Dec 04, 2021",
    //   read: false,
    //   type: TABLES.CAMPAIGN,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "6",
    //   title: "Deal won",
    //   owner: "Neha Paresh",
    //   date: "Oct 16, 2021",
    //   read: true,
    //   type: TABLES.DEAL,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "7",
    //   title: "Landing page created",
    //   owner: "David Zhang",
    //   date: "Apr 25, 2020",
    //   read: true,
    //   type: TABLES.LANDING_PAGE,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "8",
    //   title: "Contact <b>Paresh Rao</b> updated",
    //   owner: "Victoria Perez",
    //   date: "Jun 18, 2020",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "9",
    //   title: "<b>Anand Gurnani</b> added to list",
    //   owner: "Sally Spicer",
    //   date: "Aug 03, 2020",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "10",
    //   title: "Contact added - <b>Name</b>",
    //   owner: "John Carter",
    //   date: "Jun 18, 2021",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "11",
    //   title: "<b>$ 23,000</b> Deal receive",
    //   owner: "Monica Bel",
    //   date: "May 23, 2021",
    //   read: true,
    //   type: TABLES.DEAL,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "12",
    //   title: "Contact <b>Paresh Rao</b> updated",
    //   owner: "Victoria Perez",
    //   date: "Jun 18, 2020",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "13",
    //   title: "<b>Anand Gurnani</b> added to list",
    //   owner: "Sally Spicer",
    //   date: "Aug 03, 2020",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "14",
    //   title: "Contact added - <b>Name</b>",
    //   owner: "John Carter",
    //   date: "Jun 18, 2021",
    //   read: true,
    //   type: TABLES.CONTACT,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // },
    // {
    //   id: "15",
    //   title: "<b>$ 23,000</b> Deal receive",
    //   owner: "Monica Bel",
    //   date: "May 23, 2021",
    //   read: true,
    //   type: TABLES.DEAL,
    //   documentId: "DHSADH-283929H-DJAD82-NHSAIU2526",
    // }
  ];
  static getNotifications() {
    // will use later
  }
  static processBeforeDislay(responseData) {
    
    let peopleNotification = responseData.filter(res=>{
      switch(res['module']) {
        case NOTIFICATION_MODULE.LEAVE_APPLICATION:
          res['date'] = moment(res['createdDate']).format('MMM DD, YYYY')
          res['owner'] = NOTIFICATIONS[res['activity']];
          res['title'] = res['message']
          res['read'] = (res['status'] != 'unread') ? true:false
          res['type'] = PRODUCTS.ELEAVE
          return res;

        case NOTIFICATION_MODULE.PAYRUN:
          res['date'] = moment(res['createdDate']).format('MMM DD, YYYY')
          res['owner'] = NOTIFICATIONS[res['activity']];
          res['title'] = res['message']
          res['read'] = (res['status'] != 'unread') ? true:false
          res['type'] = TABLES.PAYROLL
          res['navigateTo'] = `${res['code']}`
          return res;

        case NOTIFICATION_MODULE.USER:
          res['date'] = moment(res['createdDate']).format('MMM DD, YYYY')
          res['owner'] = NOTIFICATIONS[res['activity']];
          res['title'] = res['message']
          res['read'] = (res['status'] != 'unread') ? true:false
          res['type'] = TABLES.EMPLOYEE_LIST
          // res['documentId'] = "";
          return res;
        
        case NOTIFICATION_MODULE.PAYMENT:
          res['date'] = moment(res['createdDate']).format('MMM DD, YYYY')
          res['owner'] = NOTIFICATIONS[res['activity']];
          res['title'] = res['message']
          res['read'] = (res['status'] != 'unread') ? true:false
          res['type'] = TABLES.PAYROLL
          res['navigateTo'] = `${res['code']}`
          return res;
      }      
    })
    
    return peopleNotification;
  }

  static markNotificationAsRead(index) {
    let notification = NotificationManager.notifications[index];
    notification.read = true;
  }

  static navigateToRespectiveSection = (data, index) => {
    // NotificationManager.markNotificationAsRead(index);
    switch (data.type) {
      case TABLES.CONTACT:
        RouteManager.navigateToPage(PAGE_ROUTES.CONTACTS);
        break;
      case TABLES.PAYROLL:
        if(data.navigateTo) {
          RouteManager.navigateToPage('process-summary',`id=${data.navigateTo}&navigatedFrom=notification`);
        } else {
          RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
        }
        break;
      case TABLES.FORM:
        RouteManager.navigateToPage(PAGE_ROUTES.FORMS);
        break;
        case TABLES.PEOPLE_EMAIL_TEMPLATE:
        RouteManager.navigateToPage(PAGE_ROUTES.EMAIL_TEMPLATE.LIST);
        break;
      case TABLES.LANDING_PAGE:
        RouteManager.navigateToPage(PAGE_ROUTES.LANDING_PAGE);
        break;
      case TABLES.CAMPAIGN:
        RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN);
      case PRODUCTS.ELEAVE:
        NotificationManager.routeToPage(ApiConstants.PRODUCT_URL_ELEAVE)
        break;
      case TABLES.EMPLOYEE_LIST:
        let routPath = '';
        if(data.activity == 'INCOMPLETE_USER' || data.activity == 'INCOMPLETE_USER_ADMIN') {
          routPath = PAGE_ROUTES.EMPLOYEE_LIST+'/?filter=true'
        } else {
          routPath = PAGE_ROUTES.EMPLOYEE_LIST
        }
        RouteManager.navigateToPage(routPath)
        break;
      default:
        RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
    }
  };
  static routeToPage(url, navigateTo) {
    window.open(url, "_blank");
  }
}
